<template>
  <div class="callback-container">
    <el-spinner v-if="loading" size="large" />
    <div v-else class="success-box">
      <el-icon name="success" class="success-icon" />
      <p>登录成功，正在跳转...</p>
    </div>
  </div>
</template>

<script>
import { getSignList } from '@/api/sign'

export default {
  name: 'Callback',
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')

    if (token) {
      localStorage.setItem('sign_token', token)
      this.loading = false
      setTimeout(() => {
        this.$router.push('/')
      }, 500)
    } else {
      this.loading = false
      this.$message.error('获取登录信息失败')
    }
  }
}
</script>

<style scoped>
.callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.success-box {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.success-icon {
  font-size: 48px;
  color: #67c23a;
  margin-bottom: 16px;
}

.success-box p {
  color: #606266;
  font-size: 16px;
}
</style>